<template>
  <div class="twitter">
    <blockquote class="twitter-tweet">
      <EmbedsPlaceholder
        v-if="loadError"
        :link="src"
        class="twitter__error"
      />
      <LazyloadPlaceholder
        v-if="loading"
        class="twitter__lazyload-placeholder"
      />
      <p
        v-if="!loadError"
        lang="zxx"
        dir="ltr"
      >
        <a
          class="twitter__link"
          :href="src"
        >
          June 20, 2022
        </a>
      </p>
    </blockquote>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { addScriptIfNeeded } from '@devhacker/shared/utils/script/addScriptIfNeeded';
  import { removeScriptIfExists } from '@devhacker/shared/utils/script/removeScriptIfExists';
  import EmbedsPlaceholder from '~/components/EmbedsPlaceholder.vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  import type { IEmbedContent } from '~/types/common';

  export default defineNuxtComponent({
    name: 'TwitterEmbed',

    components: { EmbedsPlaceholder, LazyloadPlaceholder },

    props: {
      elem: {
        type: Object as PropType<IEmbedContent>,
        required: true,
      },
    },

    data: () => ({
      scriptUrl: 'https://platform.twitter.com/widgets.js',
      loadError: false,
      loading: true,
    }),

    computed: {
      src(): string {
        return this.elem.attributes.url;
      },
    },

    mounted() {
      addScriptIfNeeded(
        this.scriptUrl,
        () => {
          this.loadError = true;
          this.finishLoading();
        },
        this.finishLoading,
      );
      this.loading = true;
    },

    beforeUnmount() {
      removeScriptIfExists(this.scriptUrl);
    },

    methods: {
      finishLoading() {
        this.loading = false;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .twitter {
    display: flex;
    justify-content: center;
    position: relative;
    min-height: 160px;

    &-tweet {
      width: 100%;
    }

    &__lazyload-placeholder {
      max-width: 290px;
      margin: 0 auto;
    }

    &__error {
      max-width: 592px;
      width: 100%;
      margin: 0 auto;
    }

    &__link {
      display: none;
    }

    &__error-text {
      text-align: center;
    }

    &__error-link {
      text-align: center;
      display: block;
      color: #c722ca;
    }
    :deep() .twitter-tweet {
      margin: 0 !important;
    }
  }
</style>
